import { Box } from '@material-ui/core';
import { Invitation, OnboardingDetailsRole } from '@nemuru-eng/js-api-client';

import { RelationOptions } from '@/components/modules/KYC/KYCLoan/shared/BorrowerInvitationSection/constants/RelationOptions';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { DateFormField } from '@/components/shared/components/NewContextForms/DateFormField';
import { PhoneFormDoubleField } from '@/components/shared/components/NewContextForms/PhoneFormDoubleField/PhoneFormDoubleField';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';

interface BorrowerInvitationFormProps extends FormGridOptions {
  borrowerInvitation: Invitation;
  participantRole?: OnboardingDetailsRole;
}

export function BorrowerInvitationForm({
  borrowerInvitation,
  fullWidth = false,
  participantRole,
  fieldVariant,
}: BorrowerInvitationFormProps) {
  return (
    <Box pt={2}>
      <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
        <TextFormField
          disabled={true}
          value={`${borrowerInvitation.fullName.firstName} ${borrowerInvitation.fullName.lastName}`}
          name={'fullName'}
          label={'FULL_NAME'}
          fieldVariant={fieldVariant}
        />
        {borrowerInvitation.documentNumber && (
          <TextFormField
            disabled={true}
            value={borrowerInvitation.documentNumber}
            name={'documentNumber'}
            label={'DOCUMENT_NUMBER'}
            fieldVariant={fieldVariant}
          />
        )}
        <DateFormField
          disabled={true}
          label={'EXPIRES_ON'}
          name={'expiresOn'}
          value={borrowerInvitation.expiresOn}
          fieldVariant={fieldVariant}
        />
        <TextFormField value={borrowerInvitation.email} name={'email'} label={'EMAIL'} fieldVariant={fieldVariant} />
        <PhoneFormDoubleField fieldVariant={fieldVariant} defaultValue={borrowerInvitation.phoneNumber} />
        {participantRole !== OnboardingDetailsRole.BORROWER && (
          <SelectFormField
            name={'relation'}
            label={'RELATION'}
            value={borrowerInvitation.relation}
            selectOptions={RelationOptions}
            fieldVariant={fieldVariant}
          />
        )}
      </FormGridContainer>
    </Box>
  );
}
